import DeleteIcon from "@mui/icons-material/Delete";
import { Autocomplete, MenuItem, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  retrieveAllInventoryApi,
  retrieveFilteredInventoryApi,
} from "../../../components/api/InventoryApiService";
import { retrieveAllItemsApi } from "../../../components/api/ItemApiService";
import ExportExcel from "../../../utils/excelExport";
import AddInventory from "./AddInventory";
import EditInventory from "./EditInventory";
import {
  color,
  companies,
  incoterms,
  leafForm,
  offerStatus,
  origin,
  paymentTerm,
  recordStatus,
  sampleStatus,
  status,
  type,
  units,
} from "../../../utils/menu-items";
import MyFilters from "../../../components/MyFilters";


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const companyList = [
  {
    value: "SGE",
    label: "SGE",
  },
  {
    value: "SGI",
    label: "SGI",
  },
];

const storage = [
  {
    value: "CHINA",
    label: "CHINA",
  },
  {
    value: "THAILAND-BANGKOK",
    label: "THAILAND-BANGKOK",
  },
  {
    value: "BANGLADESH",
    label: "BANGLADESH",
  },
  {
    value: "BRAZIL",
    label: "BRAZIL",
  },
];

const headCells = [
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
  },
  {
    id: "itemId",
    numeric: false,
    disablePadding: true,
    label: "Item ID",
  },
  {
    id: "buyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
  },
  {
    id: "salesGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
  },
  {
    id: "crop",
    numeric: false,
    disablePadding: true,
    label: "Crop",
  },
  {
    id: "nicotine",
    numeric: true,
    disablePadding: true,
    label: "Nic",
  },
  {
    id: "suagr",
    numeric: true,
    disablePadding: true,
    label: "Sug",
  },
  {
    id: "origin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
  },
  {
    id: "quantityRemainingCase",
    numeric: true,
    disablePadding: true,
    label: "Available Stock (Case)",
  },
  {
    id: "quantityRemainingKg",
    numeric: true,
    disablePadding: true,
    label: "Available Stock Kg",
  },
  /*{
    id: "quantityRemainingCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. (Case)",
  },
  {
    id: "quantityRemainingKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. ",
  },*/
  {
    id: "quantityRemainingInVendorCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. In Vendor (Case)",
  },
  {
    id: "quantityRemainingInVendorKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. In Vendor",
  },
      {
    id: "quantityReservedPurchaseOrderCase",
    numeric: true,
    disablePadding: true,
    label: "Reserved PO Case",
  },
    {
    id: "quantityReservedPurchaseOrderKg",
    numeric: true,
    disablePadding: true,
    label: "Reserved PO",
  },
  {
    id: "quantityReservedInCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Res. To Customer (Case)",
  },
  {
    id: "quantityReserevdInKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Res. To Customer",
  },
        {
    id: "quantityReservedSalesOrderCase",
    numeric: true,
    disablePadding: true,
    label: "Reserved SO Case",
  },
      {
    id: "quantityReservedSalesOrderKg",
    numeric: true,
    disablePadding: true,
    label: "Reserved SO",
  },
  {
    id: "quantityRemainingInWarehouseCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. In Whs (Case)",
  },
  {
    id: "quantityRemainingInWarehouseKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Rem. In Whs",
  },
  {
    id: "quantitySentToProductionCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Sent To Prod. (Case)",
  },
  {
    id: "quantitySentToProductionKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Sent To Prod.",
  },
  {
    id: "quantitySoldToProductionCase",
    numeric: true,
    disablePadding: true,
    label: "Qty Sold To Prod. (Case)",
  },
  {
    id: "quantitySoldToProductionKg",
    numeric: true,
    disablePadding: true,
    label: "Qty Sold To Prod.",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, showFilters, setShowFilters, rows, setRows, selected,
    selectedData, setFilterInventory, filterInventory } = props;

    function formatDate(isoDateString) {
      const date = new Date(isoDateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear();
  
      return `${day}-${month}-${year}`;
    }

    function createNewExportObject(rows) {
      const newObjects = [];
      const headerMapping = {
        "Vendor Grade": (row) =>
          (row?.quantity?.item?.buyingGrade ? row?.quantity?.item?.buyingGrade : ""),
        "Sales Grade": (row) =>
          (row?.quantity?.item?.salesGrade ? row?.quantity?.item?.salesGrade : ""),
        "Internal Grade": (row) =>
          (row?.quantity?.item?.internalGrade ? row?.quantity?.item?.internalGrade : ""),
        "Crop": (row) =>
          (row?.quantity?.item?.crop ? row?.quantity?.item?.crop : ""),
        "Nicotine": (row) =>
          (row?.quantity?.item?.nicotine ? row?.quantity?.item?.nicotine : ""),
        "Sugar": (row) =>
          (row?.quantity?.item?.sugar ? row?.quantity?.item?.sugar : ""),
        "Origin": (row) =>
          (row?.quantity?.item?.origin ? row?.quantity?.item?.origin : ""),
        "Available Quantity (Case)": (row) =>
          new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(
            (row?.quantity?.quantityRemainingInWarehouseInNetCase || 0) +
            (row?.quantity?.quantityRemainingInVendorInNetCase || 0) -
            (row?.quantity?.quantityReservedToCustomerInNetCase || 0)
          ),
        "Available Quantity (Kg)": (row) =>
          new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(
            (row?.quantity?.quantityRemainingInWarehouseInNetKg || 0) +
            (row?.quantity?.quantityRemainingInVendorInNetKg || 0) -
            (row?.quantity?.quantityReservedToCustomerInNetKg || 0)
          ),
          "Quantity Remaining In Vendor (Case)": (row) =>
            row?.quantity?.quantityRemainingInVendorInNetCase ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInVendorInNetCase)}`
          : "",
          "Quantity Remaining In Vendor (Kg)": (row) =>
            row?.quantity?.quantityRemainingInVendorInNetKg ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInVendorInNetKg)}`
          : "",
          "Quantity Reserved To Customer (Case)": (row) =>
            row?.quantity?.quantityReservedToCustomerInNetCase ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityReservedToCustomerInNetCase)}`
          : "",
          "Quantity Reserved To Customer (Kg)": (row) =>
            row?.quantity?.quantityReservedToCustomerInNetKg ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityReservedToCustomerInNetKg)}`
          : "",
          "Quantity Remaining In Warehouse (Case)": (row) =>
            row?.quantity?.quantityRemainingInWarehouseInNetCase ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInWarehouseInNetCase)}`
          : "",
          "Quantity Remaining In Warehouse (Kg)": (row) =>
            row?.quantity?.quantityRemainingInWarehouseInNetKg ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInWarehouseInNetKg)}`
          : "",
          "Quantity Sent To Production (Case)": (row) =>
            row?.quantity?.quantityRemainingInProductionInNetCase ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInProductionInNetCase)}`
          : "",
          "Quantity Sent To Production (Kg)": (row) =>
            row?.quantity?.quantityRemainingInProductionInNetKg ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantityRemainingInProductionInNetKg)}`
          : "",
          "Quantity Sold To Production (Case)": (row) =>
            row?.quantity?.quantitySoldToProductionInNetCase ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantitySoldToProductionInNetCase)}`
          : "",
          "Quantity Sold To Production (Kg)": (row) =>
            row?.quantity?.quantitySoldToProductionInNetKg ? `${new Intl.NumberFormat("en-US", {
              style: "decimal",
              minimumFractionDigits: 2,
            }).format(row.quantity.quantitySoldToProductionInNetKg)}`
          : "",
        "Record Status": "recordStatus",
      };
  
      rows.forEach((row) => {
        const newObject = {};
        Object.entries(headerMapping).forEach(([header, pathOrFunction]) => {
          let value;
          if (typeof pathOrFunction === "function") {
            value = pathOrFunction(row); 
          } else {
            const keys = pathOrFunction.split("?.");
            value = row;
            for (const key of keys) {
              if (value == null) break;
              value = value[key];
            }
          }
          if (header.endsWith("Date") && value) {
            value = formatDate(value);
          }
          newObject[header] = value ?? ""; 
        });
        newObjects.push(newObject);
      });
  
      return newObjects;
    }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"}>
          <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
            variant="h6"
            id="tableTitle"
            component="div"
            color="#1E2685"
          >
            Inventory
          </Typography>

          <Typography></Typography>
          {numSelected > 0 ? (
          <Typography
          sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (<Typography></Typography>)}
        
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
          <Button
          variant="outlined"
          onClick={() => {
           
            const updatedFilterInventory = {
              ...filterInventory,
              quantityRemainingInNetKg: 1,
              quantityRemainingInVendorInNetKg: 1,
            };

            setFilterInventory(updatedFilterInventory);
            
            retrieveFilteredInventoryApi(updatedFilterInventory)
              .then((response) => {
                setRows(response?.data);
              })
              .catch((error) => {
                console.log(error?.response?.data);
              });
          }}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          In Stock
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
           
            const updatedFilterInventory = {
              ...filterInventory,
              quantityRemainingInNetKg: null,
              quantityRemainingInVendorInNetKg: null,
            };

            setFilterInventory(updatedFilterInventory);
            
            retrieveFilteredInventoryApi(updatedFilterInventory)
              .then((response) => {
                setRows(response?.data);
              })
              .catch((error) => {
                console.log(error?.response?.data);
              });
          }}
          sx={{ minWidth: "130px" }}
          size="small"
        >
           All
        </Button>
      </Stack>
      <Stack direction={"row"} spacing={1} sx={{ mr: 2 }}>
      <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"InventoryTable"}
          buttonLabel="Export Table"
        />
        <Button disableElevation variant="outlined" size="small">
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function InventoryView() {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showFilters, setShowFilters] = useState(false);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [filterInventory, setFilterInventory] = useState({
    id: 0,
    ownershipList: [],
    itemIdList: [],
    costIdList: [],
    storageList: [],
    inventoryTypeList: [],
    storageTypeList: [],
    paymentStatusList: [],
    originList: [],
    remark: "",
    recordStatusList: ["ACTIVE"],
  });

    const [componentsState, setComponentsState] = useState({
      item: {
        dropdownOpen: false,
        inputValue: "",
      },
    });

    const updateComponentState = (componentKey, newState) => {
      setComponentsState((prevState) => ({
        ...prevState,
        [componentKey]: {
          ...prevState[componentKey],
          ...newState,
        },
      }));
    };
  
  useEffect(() => retrieveInventory(), []);

  function retrieveInventory() {
    retrieveAllInventoryApi()
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [editInventory, setEditInventory] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    }else{
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editInventory],
  );

  return (
    <div>
      {addView ? (
        <AddInventory
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
        />
      ) : editInventory.visible ? (
        <EditInventory
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editInventory={editInventory}
          setEditInventory={setEditInventory}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >

             <Autocomplete
                  multiple
                  id="outlined-select-item"
                  disableClearable
                  open={componentsState.item.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("item", { dropdownOpen: true })
                  }
                  inputValue={componentsState.item.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("item", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...items.filter((item) =>
                      filterInventory.itemIdList.includes(item.id),
                    ),
                    ...items.filter(
                      (item) =>
                        !filterInventory.itemIdList.includes(item.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - BG: ${option?.buyingGrade || ""} - IG: ${option?.internalGrade || ""} - SG: ${option?.salesGrade || ""} - ${
                      option?.crop || ""
                    }`
                  }
                  value={items.filter((item) =>
                    filterInventory.itemIdList.includes(item.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterInventory({
                      ...filterInventory,
                      itemIdList: newValue.map((item) => item.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - BG: ${option?.buyingGrade || ""} - IG: ${option?.internalGrade || ""} - SG: ${option?.salesGrade || ""} - ${
                        option?.crop || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterInventory?.itemIdList.length > 0
                        ? `Items Selected (${filterInventory?.itemIdList.length})`
                        : "Item";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.item.inputValue}
                        onChange={(e) =>
                          updateComponentState("item", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveItems}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("item", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-number"
                  label="Buying Grade"
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      buyingGrade: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Sales Grade"
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      salesGrade: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Internal Grade"
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      internalGrade: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Origin"
                  type="search"
                  id="outlined-select-origin"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.originList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        originList: e.target.value,
                      });
                    },
                  }}
                >
                  {origin.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  id="outlined-number"
                  label="Nicotine"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      nicotine: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Sugar"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      sugar: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Current Location"
                  type="search"
                  id="outlined-select-storage"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.storageList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        storageList: e.target.value,
                      });
                    },
                  }}
                >
                  {storage.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Storage Type"
                  type="search"
                  id="outlined-select-storage-type"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.storageTypeList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        storageTypeList: e.target.value,
                      });
                    },
                  }}
                >
                  {storage.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="outlined-number"
                  label="Payment Amount"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      paymentAmount: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Payment Status"
                  type="search"
                  id="outlined-select-payment-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.paymentStatusList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        paymentStatusList: e.target.value,
                      });
                    },
                  }}
                >
                  {companyList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  id="outlined-number"
                  label="Remaining Payment"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      remainingPayment: e.target.value,
                    })
                  }
                />
                <TextField
                  id="date"
                  type="date"
                  label="Payment Deadline"
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      paymentDeadline: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Inventory Type"
                  type="search"
                  id="outlined-select-inventory-type"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.inventoryTypeList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        inventoryTypeList: e.target.value,
                      });
                    },
                  }}
                >
                  {companyList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="outlined-number"
                  label="Net Weight Per Carton"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      netWeightPerCase: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Number Of Cartons"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      numberOfCases: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="Entry Date"
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      entryDate: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="Exit Date"
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      exitDate: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="Shipping Deadline"
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      shippingDeadline: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Shipped Out In Carton"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      shippedOutCase: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Shipped Out In Kg"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      shippedOutKg: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Shipped In In Carton"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      shippedInCase: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Shipped In In Kg"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      shippedInKg: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Final Stock"
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      finalStock: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Rejection"
                  type="search"
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      rejection: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Remark"
                  type="search"
                  onChange={(e) =>
                    setFilterInventory({
                      ...filterInventory,
                      remark: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Record Status"
                  type="search"
                  id="outlined-select-record-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterInventory.recordStatusList || [],
                    onChange: (e) => {
                      setFilterInventory({
                        ...filterInventory,
                        recordStatusList: e.target.value,
                      });
                    },
                  }}
                >
                  {recordStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                    <MyFilters
                      componentName="InventoryView"
                      filterState={filterInventory}
                      onApply={(saved) => setFilterInventory(saved)}
                    />
              </Grid>
              <br></br>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      retrieveFilteredInventoryApi(filterInventory)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                setRows={setRows}
                selected={selected}
                selectedData={selectedData}
                setFilterInventory = {setFilterInventory}
                filterInventory = {filterInventory}
              />
             <TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    '& .MuiTableCell-head': {
                      backgroundColor: '#20315d',
                      color: 'white',
                      fontSize: '12px',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      lineHeight: 1.2, 
                    },
                    '& .MuiTableCell-body': {
                      fontSize: '12px', 
                      padding: '1px 3px',
                      lineHeight: 1.0, 
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "4000px" }}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            index % 2
                              ? { background: "#f0f0f0" }
                              : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">{row?.id}</TableCell>
                          <TableCell align="center">{row?.quantity?.item?.id}</TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.buyingGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.salesGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.crop}
                          </TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.nicotine}
                          </TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.sugar}
                          </TableCell>
                          <TableCell align="center">
                            {row?.quantity?.item?.origin}
                          </TableCell>
                          {/*<TableCell align="center" style={{ backgroundColor: '#FFADAD' }}>
                            {row?.quantity?.quantityRemainingInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#FFADAD' }}>
                            {row?.quantity?.quantityRemainingInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInNetKg)}`
                              : ""}{" "}
                          </TableCell>*/}
                          <TableCell align="center" style={{ backgroundColor: '#FFADAD' }}>
                              {new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(
                                (row?.quantity?.quantityRemainingInWarehouseInNetCase || 0) +
                                (row?.quantity?.quantityReservedPurchaseOrderInNetCase || 0)+
                                (row?.quantity?.quantityRemainingInVendorInNetCase || 0) -
                                (row?.quantity?.quantityReservedSalesOrderInNetCase || 0)-
                                (row?.quantity?.quantityReservedToCustomerInNetCase || 0)
                              )}
                            </TableCell>
                            <TableCell align="center" style={{ backgroundColor: '#FFADAD' }}>
                              {new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(
                                (row?.quantity?.quantityRemainingInWarehouseInNetKg || 0) +
                                (row?.quantity?.quantityReservedPurchaseOrderInNetKg || 0)+
                                (row?.quantity?.quantityRemainingInVendorInNetKg || 0) -
                                (row?.quantity?.quantityReservedSalesOrderInNetKg || 0)-
                                (row?.quantity?.quantityReservedToCustomerInNetKg || 0)
                              )}
                            </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#FFD6A5' }}>
                            {row?.quantity?.quantityRemainingInVendorInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInVendorInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#FFD6A5' }}>
                            {row?.quantity?.quantityRemainingInVendorInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInVendorInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                                                                              <TableCell align="center" style={{ backgroundColor: '#FFD6A5' }}>
                            {row?.quantity?.quantityReservedPurchaseOrderInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedPurchaseOrderInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: '#FFD6A5' }}>
                            {row?.quantity?.quantityReservedPurchaseOrderInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedPurchaseOrderInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#FDFFB6' }}>
                            {row?.quantity?.quantityReservedToCustomerInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedToCustomerInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#FDFFB6' }}>
                            {row?.quantity?.quantityReservedToCustomerInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedToCustomerInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                                                      <TableCell align="center" style={{ backgroundColor: '#FDFFB6' }}>
                            {row?.quantity?.quantityReservedSalesOrderInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedSalesOrderInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                            <TableCell align="center" style={{ backgroundColor: '#FDFFB6' }}>
                            {row?.quantity?.quantityReservedSalesOrderInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityReservedSalesOrderInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#CAFFBF' }}>
                            {row?.quantity?.quantityRemainingInWarehouseInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInWarehouseInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#CAFFBF' }}>
                            {row?.quantity?.quantityRemainingInWarehouseInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInWarehouseInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#A0C4FF' }}>
                            {row?.quantity?.quantityRemainingInProductionInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInProductionInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#A0C4FF' }}>
                            {row?.quantity?.quantityRemainingInProductionInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantityRemainingInProductionInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#BDB2FF' }}>
                            {row?.quantity?.quantitySoldToProductionInNetCase ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantitySoldToProductionInNetCase)}`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center" style={{ backgroundColor: '#BDB2FF' }}>
                            {row?.quantity?.quantitySoldToProductionInNetKg ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.quantity.quantitySoldToProductionInNetKg)}`
                              : ""}{" "}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
        </>
      )}
    </div>
  );
}
